// src/components/ShareRedirect.js
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import SampleProducts from "./SampleProducts"; // Import your data

const ShareRedirect = () => {
  const { slugId: id } = useParams(); // Gets "FD1928374650ABCD" from the URL
  const navigate = useNavigate();

  useEffect(() => {


    // 2. Find the product data (Optional, but good for safety)
    const product = SampleProducts.find((p) => p.id === id);

    if (product) {
      // 3. Redirect to the SECURE route
      navigate(`/business-product/${id}`, { 
        replace: true,
        // CRITICAL: We pass the product data in state so SingleProduct.js doesn't crash
        state: { product: product } 
      });
    } else {
      // If ID is wrong, go to 404
      navigate("/404");
    }
  }, [id, navigate]);

  return (
    <div style={{ 
      height: "100vh", 
      display: "flex", 
      justifyContent: "center", 
      alignItems: "center",
      background: "#fff",
      flexDirection: "column"
    }}>
      {/* You can put your MarsMate Loader here */}
      <h3>Verifying Secure Link...</h3>
    </div>
  );
};

export default ShareRedirect;